export const getMRZ = (mrz = "") => {
  try {
    const myRegexp = /P<(.*?)(<<<)/g;
    const match = myRegexp.exec(mrz) || [];
    const matchText = (match[1] || "").trim();
    const countryCode = matchText.slice(0, 3) || "";
    const name = matchText.slice(3);
    const [firstName, lastName] = name.split("<<");

    return {
      countryCode,
      firstName,
      lastName,
    };
  } catch (error) {
    return {
      countryCode: "",
      firstName: "",
      lastName: "",
    };
  }
};
